export const config = {
  // URL: "http://localhost:3040",
  URL: "https://api.redeprocursos.com.br",
};
